// extracted by mini-css-extract-plugin
export default {"tab_menu":"TabMenu2_tab_menu__spZpL"};